module.exports = __webpack_public_path__ + "img/魏县计量衡器.c9061459.jpg";